import { EntityGoal } from "../../entity/EntityGoal";

export class DtoGoalsPutRes extends EntityGoal {}
